import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/dragQuestion/left.png'
import _imports_1 from '@/assets/dragQuestion/right.png'


const _withScopeId = n => (_pushScopeId("data-v-231f2cc0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dv-question-title img-drag" }
const _hoisted_2 = { style: {"display":"flex"} }
const _hoisted_3 = {
  key: 0,
  class: "dv-title-index"
}
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = {
  key: 1,
  class: "dv-title-score"
}
const _hoisted_6 = ["height", "width", "innerHTML"]
const _hoisted_7 = { class: "firstItem" }
const _hoisted_8 = {
  class: "dvImg",
  src: _imports_0
}
const _hoisted_9 = { class: "firstItemContent" }
const _hoisted_10 = { class: "firstItemTitle" }
const _hoisted_11 = ["draggable", "type", "dataId", "secondItemId"]
const _hoisted_12 = {
  key: 1,
  class: "emptyOption"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "emptyOptionText" }, "请将正确答案拖拽至框中", -1))
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = {
  class: "dvImg",
  src: _imports_1
}
const _hoisted_16 = ["type"]
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-title" }, "选项区域:", -1))
const _hoisted_18 = ["type"]
const _hoisted_19 = ["draggable", "type", "dataId"]
const _hoisted_20 = {
  key: 1,
  class: "question-correct_answer"
}
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "correct_answer-title" }, "正确答案:", -1))
const _hoisted_22 = [
  _hoisted_21
]
const _hoisted_23 = {
  key: 2,
  class: "firstItem"
}
const _hoisted_24 = {
  class: "dvImg",
  src: _imports_0
}
const _hoisted_25 = { class: "firstItemContent" }
const _hoisted_26 = { class: "firstItemTitle" }
const _hoisted_27 = { class: "firstItemDragBody richText" }
const _hoisted_28 = {
  class: "dvImg",
  src: _imports_1
}
const _hoisted_29 = {
  key: 3,
  class: "question-analysis"
}
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "analysis-title" }, "解析:", -1))
const _hoisted_31 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DynamicContent = _resolveComponent("DynamicContent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.props.showQuestionNum)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.questionData.indexInQuestion !== undefined
            ? _ctx.questionData.indexInQuestion + "."
            : "") + _toDisplayString(_ctx.questionData.titleNum > 0 ? _ctx.questionData.titleNum : ""), 1))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        innerHTML: _ctx.questionData.title,
        id: "dvCompile",
        class: "dv-title",
        ref: "questionTitle"
      }, null, 8, _hoisted_4),
      (_ctx.props.showQuestionScore)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, " (" + _toDisplayString(_ctx.questionData.score) + "分) ", 1))
        : _createCommentVNode("", true)
    ]),
    (_ctx.draggingImgData.show)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          height: _ctx.draggingImgData.height,
          width: _ctx.draggingImgData.width,
          class: "maskImg",
          innerHTML: _ctx.draggingImgData?.content || '',
          style: _normalizeStyle(_ctx.draggingImgData.style)
        }, null, 12, _hoisted_6))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", {
        class: "firstItemBtn",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goLeft && _ctx.goLeft(...args)))
      }, [
        _withDirectives(_createElementVNode("img", _hoisted_8, null, 512), [
          [_vShow, _ctx.firstItems.length > 2]
        ])
      ]),
      _createElementVNode("div", {
        id: "dragMiddle",
        class: "firstItemMiddle",
        style: _normalizeStyle({
          justifyContent: _ctx.firstItems.length > 2 ? 'flex-start' : 'center',
        }),
        onTouchstart: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.moveStart && _ctx.moveStart(...args))),
        onTouchmove: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onMove && _ctx.onMove(...args))),
        onTouchend: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.moveEnd && _ctx.moveEnd(...args)))
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.firstItems, (item) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "firstItemBody",
            key: item.id
          }, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createVNode(_component_DynamicContent, {
                  isResizeImgToRem: false,
                  simple: true,
                  content: item.content
                }, null, 8, ["content"])
              ]),
              _createElementVNode("div", {
                class: "firstItemDragBody richText",
                draggable: !_ctx.isPreview,
                type: _ctx.typeMap.firstItem.value,
                dataId: item.id,
                secondItemId: item.secondItemId
              }, [
                (item.secondItemContent)
                  ? (_openBlock(), _createBlock(_component_DynamicContent, {
                      key: 0,
                      simple: true,
                      content: item.secondItemContent,
                      isResizeImgToRem: false
                    }, null, 8, ["content"]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_12, _hoisted_14))
              ], 8, _hoisted_11)
            ])
          ]))
        }), 128))
      ], 36),
      _createElementVNode("div", {
        class: "firstItemBtn",
        onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.goRight && _ctx.goRight(...args)))
      }, [
        _withDirectives(_createElementVNode("img", _hoisted_15, null, 512), [
          [_vShow, _ctx.firstItems.length > 2]
        ])
      ])
    ]),
    _createElementVNode("div", {
      class: "secondItems",
      dropArea: true,
      type: _ctx.typeMap.secondItem.value
    }, [
      _hoisted_17,
      _createElementVNode("div", {
        class: "secondItemsContent",
        type: _ctx.typeMap.secondItem.value
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.secondItems, (item) => {
          return (_openBlock(), _createElementBlock("div", {
            draggable: !_ctx.isPreview,
            type: _ctx.typeMap.secondItem.value,
            class: "secondItem richText",
            key: item.id,
            dataId: item.id
          }, [
            _createVNode(_component_DynamicContent, {
              isResizeImgToRem: false,
              simple: true,
              content: item.content
            }, null, 8, ["content"])
          ], 8, _hoisted_19))
        }), 128))
      ], 8, _hoisted_18)
    ], 8, _hoisted_16),
    (_ctx.props.disabled)
      ? (_openBlock(), _createElementBlock("div", _hoisted_20, _hoisted_22))
      : _createCommentVNode("", true),
    (_ctx.props.disabled)
      ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
          _createElementVNode("div", {
            class: "firstItemBtn",
            onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.goLeftCorrect && _ctx.goLeftCorrect(...args)))
          }, [
            _withDirectives(_createElementVNode("img", _hoisted_24, null, 512), [
              [_vShow, _ctx.firstItems.length > 2]
            ])
          ]),
          _createElementVNode("div", {
            id: "dragMiddleCorrect",
            style: _normalizeStyle({
          justifyContent: _ctx.firstItems.length > 2 ? 'flex-start' : 'center',
        }),
            class: "firstItemMiddle",
            onTouchstart: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.moveStart && _ctx.moveStart(...args))),
            onTouchmove: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.onMove && _ctx.onMove(...args))),
            onTouchend: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.moveEnd && _ctx.moveEnd(...args)))
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.correctAnswerList, (item) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "firstItemBody",
                key: item.first_item_id
              }, [
                _createElementVNode("div", _hoisted_25, [
                  _createElementVNode("div", _hoisted_26, [
                    _createVNode(_component_DynamicContent, {
                      simple: true,
                      content: item.first_item_content,
                      isResizeImgToRem: false
                    }, null, 8, ["content"])
                  ]),
                  _createElementVNode("div", _hoisted_27, [
                    _createVNode(_component_DynamicContent, {
                      simple: true,
                      content: item.second_item_content,
                      isResizeImgToRem: false
                    }, null, 8, ["content"])
                  ])
                ])
              ]))
            }), 128))
          ], 36),
          _createElementVNode("div", {
            class: "firstItemBtn",
            onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.goRightCorrect && _ctx.goRightCorrect(...args)))
          }, [
            _withDirectives(_createElementVNode("img", _hoisted_28, null, 512), [
              [_vShow, _ctx.firstItems.length > 2]
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.props.disabled)
      ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
          _hoisted_30,
          _createElementVNode("div", {
            class: "analysis-content",
            innerHTML: _ctx.question?.analysis || ''
          }, null, 8, _hoisted_31)
        ]))
      : _createCommentVNode("", true)
  ]))
}